import { render, staticRenderFns } from "./SaveAsInstantModel.vue?vue&type=template&id=5672107e"
import script from "./SaveAsInstantModel.vue?vue&type=script&lang=js"
export * from "./SaveAsInstantModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports